// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"54753799","453":"70d4c0ee","980":"5ba42bfd"}[chunkId] + ".chunk.js";
};